import {RxJsonSchema} from 'rxdb';

export const SkinConditionSchema: RxJsonSchema | any = {
    "version": 1,
    "type": "object",
    "title": "Skin Condition",
    "properties": {
        "date": {
            "type": "string"
        },
        "comment": {
            "type": "string"
        },

        "left_inside": {
            "type": "string"
        },
        "left_outside": {
            "type": "string"
        },
        "right_inside": {
            "type": "string"
        },
        "right_outside": {
            "type": "string"
        },

    },
    "required": [
        "date",
    ],
};
